import React from 'react';
import _ from 'lodash';

import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router';

import ButtonDropdown from 'components/ButtonDropdown';
import SearchFilter from 'components/Filters/SearchFilter';
import ButtonSwitch from 'components/ButtonSwitch';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';
import {openModal} from 'ducks/modals';
import {MODALS, selectViewOptions, VIEW_CHOICES} from 'ducks/allocations';

import './styles.css';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
  statistics: any;
  toggleStatisticsBox: any;
  redirectToRoomPurposes: any;
}

class SubNavigation extends React.Component<
  SubNavigationProps &
    RouteComponentProps<{locationRef: string}> &
    typeof mapDispatchToProps
> {
  openCreateRoomModal = () => {
    const {locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.CREATE_ROOM
      },
      () => this.props.openModal(MODALS.CREATE_ROOM, {locationRef})
    );
  };
  openArchiveRoomModal = () => {
    const {locationRef} = this.props.match.params;
    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.ARCHIVE_ROOM
      },
      () => this.props.openModal(MODALS.ARCHIVE_ROOM, {locationRef})
    );
  };

  openUndoArchiveRoomModal = () => {
    const {locationRef} = this.props.match.params;
    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.ARCHIVE_ROOM
      },
      () => this.props.openModal(MODALS.UNDO_ARCHIVE_ROOM, {locationRef})
    );
  };

  render() {
    const {statistics: {regularRooms, dummyRooms}} = this.props;
    const shouldDisplayStatistics =
      !_.isNil(regularRooms) && !_.isNil(dummyRooms);

    return (
      <div className="SubNavigation colab-sidepadding-2 colab-centered colab-row-space-between">
        <div
          onClick={this.props.toggleStatisticsBox}
          className="statistics colab-clickable colab-bold">
          {shouldDisplayStatistics && (
            <React.Fragment>
              {regularRooms} results{' '}
              <div className="dummy">({dummyRooms} dummy)</div>
            </React.Fragment>
          )}
        </div>
        <ButtonSwitch
          className="AllocationsViewSwitch"
          options={selectViewOptions}
          initialValue={VIEW_CHOICES.ALLOCATIONS}
          onChange={() => this.props.redirectToRoomPurposes()}
        />
        <div className="filtersSection colab-elements-row">
          <SearchFilter
            value={this.props.filters.search}
            onChange={(search: string) =>
              this.props.setFilter('search', search)
            }
          />
          <ButtonDropdown
            title="Update Room"
            className="updateOptionsButton"
            menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM}>
            <ButtonDropdown.Option
              className="option"
              onClick={this.openCreateRoomModal}>
              Add Room
            </ButtonDropdown.Option>
            <ButtonDropdown.Option
              className="option"
              onClick={this.openArchiveRoomModal}>
              Archive Room
            </ButtonDropdown.Option>
            <ButtonDropdown.Option
              className="option"
              onClick={this.openUndoArchiveRoomModal}>
              Undo Archive
            </ButtonDropdown.Option>
          </ButtonDropdown>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  requiresPermission,
  openModal
};

export default withRouter(
  connect(null, mapDispatchToProps)(SubNavigation)
) as React.ComponentType<SubNavigationProps>;
